import { render } from "./FlatLayout.vue?vue&type=template&id=1be91944&scoped=true"
import script from "./FlatLayout.vue?vue&type=script&lang=js"
export * from "./FlatLayout.vue?vue&type=script&lang=js"

import "./FlatLayout.vue?vue&type=style&index=0&id=1be91944&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\onix.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be91944"]])

export default __exports__